/* eslint-disable sonarjs/no-duplicated-branches */
import {
  FETCH_NEWSLETTERS_START,
  FETCH_NEWSLETTERS_SUCCESS,
  FETCH_NEWSLETTERS_ERROR,
  FETCH_NEWSLETTER_DETAIL_START,
  FETCH_NEWSLETTER_DETAIL_SUCCESS,
  FETCH_NEWSLETTER_DETAIL_ERROR,
  NEWSLETTER_CALENDER_YEAR_CHANGED,
} from "actions/newsletterActions";

const initialState = {
  data: [],
  planYears: [],
  selectedItem: {},
  params: {
    page: 0,
    pageSize: 20,
  },
  hasMore: false,
  isFetching: false,
  err: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NEWSLETTERS_START:
    case FETCH_NEWSLETTER_DETAIL_START:
      return {
        ...state,
        isFetching: true,
        err: "",
      };
    case FETCH_NEWSLETTERS_SUCCESS:
      return {
        ...state,
        data: [...state.data, ...action.payload.newsletters],
        planYears: [...action.payload.calendarYears],
        hasMore: action.payload.hasMore,
        params: {
          ...state.params,
          page: state.params.page + 1,
        },
        isFetching: false,
        err: "",
      };
    case FETCH_NEWSLETTER_DETAIL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        err: "",
        selectedItem: action.payload,
      };
    case NEWSLETTER_CALENDER_YEAR_CHANGED:
      return {
        ...initialState,
      };
    case FETCH_NEWSLETTERS_ERROR:
    case FETCH_NEWSLETTER_DETAIL_ERROR:
      return {
        ...state,
        err: action.payload,
        isFetching: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/newslettersReducer.js